module.exports = __webpack_public_path__ + "05-thumbnail.jpg?08944ab2da46ade06eea51919f43b958";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/05-thumbnail.jpg
// module id = 42
// module chunks = 0